"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSVWriter = void 0;
var CSVOption_1 = require("./CSVOption");
var TDNode_1 = require("../TDNode");
var StringBuilder_1 = require("../core/StringBuilder");
var StringUtil_1 = require("../core/StringUtil");
var ClassUtil_1 = require("../core/ClassUtil");
var contains = StringUtil_1.StringUtil.contains;
var CSVWriter = /** @class */ (function () {
    function CSVWriter() {
    }
    CSVWriter.get = function () {
        return CSVWriter.instance;
    };
    CSVWriter.prototype.writeAsString = function (node, opt) {
        if (opt === void 0) { opt = new CSVOption_1.CSVOption(); }
        return this.write(new StringBuilder_1.StringBuilder(), node, opt).toString();
    };
    CSVWriter.prototype.write = function (out, node, opt) {
        if (!opt.includeHeader) {
            this.writeRecords(out, node.childrenValueAsListOfList(), opt);
        }
        else {
            var keys = node.getChildrenKeys();
            if (node.type === TDNode_1.TDNodeType.ARRAY && keys.length > 0)
                keys.shift(); // Remove array index key
            this.append(out, this.encodeRecord(keys, opt), opt.recordSep);
            this.writeRecords(out, node.childrenValueAsListOfListWithKeys(keys), opt);
        }
        return out;
    };
    CSVWriter.prototype.writeRecords = function (out, records, opt) {
        var _this = this;
        records.forEach(function (r) { return _this.append(out, _this.encodeRecord(r, opt), opt.recordSep); });
        return out;
    };
    CSVWriter.prototype.append = function (out) {
        var strs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            strs[_i - 1] = arguments[_i];
        }
        for (var _a = 0, strs_1 = strs; _a < strs_1.length; _a++) {
            var s = strs_1[_a];
            out.append(s);
        }
    };
    CSVWriter.prototype.encodeRecord = function (fields, opt) {
        var _this = this;
        return fields.map(function (f) { return _this.encodeField(f, opt); }).join(opt.fieldSep);
    };
    CSVWriter.prototype.encodeField = function (field, opt) {
        var quote = opt.quoteChar;
        var str = "" + field;
        if (this.needQuote(field, opt)) {
            if (str.indexOf(quote) > 0)
                // Very important to replace globally with RegExp. Otherwise, will only replace first occurence
                str = str.replace(new RegExp(quote, 'g'), quote + quote);
            return quote + str + quote;
        }
        return str;
    };
    CSVWriter.prototype.needQuote = function (field, opt) {
        if (typeof (field) !== 'string')
            return false;
        var str = field;
        return contains(str, opt.quoteChar)
            || contains(str, opt.fieldSep)
            || contains(str, opt.recordSep)
            || typeof (ClassUtil_1.ClassUtil.toSimpleObject(str)) !== 'string';
    };
    CSVWriter.instance = new CSVWriter();
    return CSVWriter;
}());
exports.CSVWriter = CSVWriter;
//# sourceMappingURL=CSVWriter.js.map